import { createActions } from 'redux-actions';

import types from 'state/mrDistribution/extras/actionTypes';

const { mrDistribution } = createActions({
  [types.SET_EXTRA]: (extra) => ({ extra }),
  [types.SET_EXTRAS]: (extras) => ({ extrasValues: extras }),
});

export default mrDistribution;
